export default __webpack_public_path__ + "static/media/humidity.e1aaff6f.svg";